import {toast} from '@common-web/hooks/use-toast';
import type {RouterOutput} from '@common-web/lib/trpc';

export type GroupDetail = NonNullable<RouterOutput['internal']['groupPipeline']['detail']>;
export type GroupPipelineDetail = NonNullable<GroupDetail['pipeline']>;

export const comingSoon = (feature: string) => () => toast({title: `${feature} is coming soon`});

// VBA dates are stored at midnight UTC; format in UTC so they don't shift a day.
export function formatDate(value: Date | string | null): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
